/**
 * Created by Florin David on 05/04/2017.
 */
import { dispatch } from 'lib/store'

import {
  CLEAR_GENERIC_APP_ERROR,
  SET_GENERIC_APP_ERROR,
  SET_OFFLINE,
  SET_SMALL_SCREEN_SIZE,
  SET_UPDATE_IN_PROGRESS,
  SET_UPDATE_READY,
} from 'constants/action-types'

export const setUpdateInProgress = (inProgress: boolean): void =>
  dispatch(SET_UPDATE_IN_PROGRESS, inProgress)

export const setUpdateReady = (ready: boolean): void =>
  dispatch(SET_UPDATE_READY, ready)

/**
 * Set generic error
 *
 * @param {Object} params
 * @param {String} params.title
 * @param {String} params.message
 * @param {String} params.bodyClassName
 * @param {String} params.stackClassName
 * @param {Object} params.confirm
 * @param {String} params.confirm.label
 * @param {String} params.confirm.nextUrl
 *
 * @return {Promise.<*>}
 */
export const setGenericError = (params: GenericError): void => {
  const { bodyClassName, stackClassName, title, message, messageId, confirm } =
    params

  return dispatch(SET_GENERIC_APP_ERROR, {
    bodyClassName,
    stackClassName,
    title,
    message,
    messageId,
    confirm,
  })
}

export const closeGenericError = (): void => {
  dispatch(CLEAR_GENERIC_APP_ERROR)
}

export const setOffline = (offline: boolean): void => {
  dispatch(SET_OFFLINE, offline)
}

export const setSmallScreenSize = (screenSizeSmall: boolean): void => {
  dispatch(SET_SMALL_SCREEN_SIZE, screenSizeSmall)
}
